"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.YEAR_ARRAY = exports.COLOR_TYPES_ARRAY = exports.COLORS_ARRAY = exports.COUNTRY_ARRAY = exports.PRICE_ARRAY = exports.PRICE_TYPE_ARRAY = exports.POWER_ARRAY = exports.CAPACITY_ARRAY = exports.COURSE_ARRAY = exports.BODY_TYPE_MOTO_ARRAY = exports.BODY_TYPE_TRUCK_ARRAY = exports.BODY_TYPE_CAR_ARRAY = exports.FUEL_MOTO_ARRAY = exports.FUEL_ARRAY = exports.GEAR_MOTO_ARRAY = exports.GEAR_ARRAY = exports.FINANCE_ARRAY = exports.INVOICE_ARRAY = exports.PRICE_TYPES_ARRAY = exports.PRODUCT_TYPES_ARRAY = exports.STATES_ARRAY = void 0;
exports.STATES_ARRAY = [
    ["Nowy", "brandNew"],
    ["Używany", "used"],
];
exports.PRODUCT_TYPES_ARRAY = [
    ["Osobowe", "car"],
    ["Dostawcze", "truck"],
    ["Motocykle", "motorbikes"],
];
exports.PRICE_TYPES_ARRAY = [
    ["netto", "nett"],
    ["brutto", "gross"],
];
exports.INVOICE_ARRAY = [
    ["Brak", "none"],
    ["VAT", "vat"],
    ["VAT marża", "vat_discount"],
];
exports.FINANCE_ARRAY = [
    ["Leasing", "leasing"],
    ["Kredyt", "credit"],
];
exports.GEAR_ARRAY = [
    ["Manualna", "manual"],
    ["Automatyczna", "automatic"],
];
exports.GEAR_MOTO_ARRAY = [
    ["Manualna", "manual"],
    ["Automatyczna", "automatic"],
    ["Bezstopniowa", "stepless"],
    ["Półautomatyczna", "semiAutomatic"],
];
exports.FUEL_ARRAY = [
    ["Diesel", "diesel"],
    ["Benzyna", "petrol"],
    ["Hybryda", "hybrid"],
    ["Benzyna + LPG", "petrolLpg"],
    ["Elektryczne", "electric"],
];
exports.FUEL_MOTO_ARRAY = [
    ["Diesel", "diesel"],
    ["Benzyna", "petrol"],
    ["Elektryczne", "electric"],
];
exports.BODY_TYPE_CAR_ARRAY = [
    ["Auto małe", "mini"],
    ["Auto miejskie", "cityCar"],
    ["Coupe", "coupe"],
    ["Kompakt", "compact"],
    ["Hatchback", "hatchback"],
    ["Kombi", "combi"],
    ["Sedan", "sedan"],
    ["Kabriolet", "cabrio"],
    ["SUV", "suv"],
    ["Minivan", "minivan"],
];
exports.BODY_TYPE_TRUCK_ARRAY = [
    ["Autolaweta", "carCarrier"],
    ["Do zabudowy", "builtIn"],
    ["Doka", "doubleCab"],
    ["Kontener", "container"],
    ["Plandeka", "softShell"],
    ["Skrzynia", "dropside"],
    ["Wywrotka", "dumper"],
    ["Chłodnia", "temperatureControlled"],
    ["Furgon", "panelVan"],
    ["Kamper", "rvs"],
    ["Mikrobus", "microbuses"],
    ["Pick-up", "pickUp"],
    ["Platformy", "platforms"],
    ["Specjalny", "special"],
    ["Van", "vans"],
    ["Inne", "others"],
];
exports.BODY_TYPE_MOTO_ARRAY = [
    ["Chopper", "chopper"],
    ["Cruiser", "typCruiser"],
    ["Enduro", "typEnduro"],
    ["Krosowy", "cross"],
    ["Motorower", "moped"],
    ["Naked", "typNaked"],
    ["Quad", "typQuad"],
    ["Skuter", "scooter"],
    ["Sportowy", "sport"],
    ["Turystyczny", "touring"],
];
exports.COURSE_ARRAY = [
    ["20 000 km", 20000],
    ["35 000 km", 35000],
    ["50 000 km", 50000],
    ["75 000 km", 75000],
    ["100 000 km", 100000],
    ["125 000 km", 125000],
    ["150 000 km", 150000],
    ["175 000 km", 175000],
    ["200 000 km", 200000],
    ["250 000 km", 250000],
    ["300 000 km", 300000],
];
exports.CAPACITY_ARRAY = [
    ["50 cm3", 50],
    ["80 cm3", 80],
    ["125 cm3", 125],
    ["200 cm3", 200],
    ["500 cm3", 500],
    ["600 cm3", 600],
    ["750 cm3", 750],
    ["1 000 cm3", 1000],
    ["1 100 cm3", 1100],
    ["1 200 cm3", 1200],
    ["1 300 cm3", 1300],
    ["1 400 cm3", 1400],
    ["1 500 cm3", 1500],
    ["1 600 cm3", 1600],
    ["1 700 cm3", 1700],
    ["1 800 cm3", 1800],
    ["1 900 cm3", 1900],
    ["2 000 cm3", 2000],
    ["2 250 cm3", 2250],
    ["2 500 cm3", 2500],
    ["2 750 cm3", 2750],
    ["3 000 cm3", 3000],
    ["3 500 cm3", 3500],
    ["4 000 cm3", 4000],
    ["5 000 cm3", 5000],
    ["6 000 cm3", 6000],
    ["10 000 cm3", 10000],
];
exports.POWER_ARRAY = [
    ["50 KM", 50],
    ["80 KM", 80],
    ["125 KM", 125],
    ["150 KM", 150],
    ["200 KM", 200],
    ["300 KM", 300],
    ["500 KM", 500],
    ["1 000 KM", 1000],
];
exports.PRICE_TYPE_ARRAY = [
    ["Netto", "nett"],
    ["Brutto", "gross"],
];
exports.PRICE_ARRAY = [
    ["50 000 zł", 50000],
    ["60 000 zł", 60000],
    ["70 000 zł", 70000],
    ["80 000 zł", 80000],
    ["90 000 zł", 90000],
    ["100 000 zł", 100000],
    ["125 000 zł", 125000],
    ["150 000 zł", 150000],
    ["175 000 zł", 175000],
    ["200 000 zł", 200000],
    ["250 000 zł", 250000],
    ["300 000 zł", 300000],
    ["350 000 zł", 350000],
    ["400 000 zł", 400000],
    ["500 000 zł", 500000],
    ["600 000 zł", 600000],
    ["700 000 zł", 700000],
];
exports.COUNTRY_ARRAY = [
    ["Austria", "austria"],
    ["Belgia", "belgia"],
    ["Białoruś", "bialorus"],
    ["Bułgaria", "bulgaria"],
    ["Chorwacja", "chorwacja"],
    ["Czechy", "czechy"],
    ["Dania", "dania"],
    ["Estonia", "estonia"],
    ["Finlandia", "finlandia"],
    ["Francja", "francja"],
    ["Grecja", "grecja"],
    ["Hiszpania", "hiszpania"],
    ["Holandia", "holandia"],
    ["Irlandia", "irlandia"],
    ["Islandia", "islandia"],
    ["Japonia", "japonia"],
    ["Kanada", "kanada"],
    ["Korea", "korea"],
    ["Liechtenstein", "liechtenstein"],
    ["Litwa", "litwa"],
    ["Luksemburg", "luksemburg"],
    ["Łotwa", "lotwa"],
    ["Monako", "monako"],
    ["Niemcy", "niemcy"],
    ["Norwegia", "norwegia"],
    ["Polska", "polska"],
    ["Rosja", "rosja"],
    ["Rumunia", "rumunia"],
    ["Słowacja", "slowacja"],
    ["Słowenia", "slowenia"],
    ["Stany Zjednoczone", "usa"],
    ["Szwajcaria", "szwajcaria"],
    ["Szwecja", "szwecja"],
    ["Turcja", "turcja"],
    ["Ukraina", "ukraina"],
    ["Węgry", "wegry"],
    ["Wielka Brytania", "wielka-brytania"],
    ["Włochy", "wlochy"],
    ["Inny", "other"],
];
exports.COLORS_ARRAY = [
    ["Beżowy", "brown-beige"],
    ["Biały", "white"],
    ["Brązowy", "brown"],
    ["Bordowy", "dark-red"],
    ["Czarny", "black"],
    ["Czerwony", "red"],
    ["Pomarańczowy", "orange"],
    ["Fioletowy", "violet"],
    ["Niebieski", "blue"],
    ["Granatowy", "navy-blue"],
    ["Błękitny", "sky-blue"],
    ["Srebrny", "silver"],
    ["Szary", "grey"],
    ["Zielony", "green"],
    ["Złoty", "yellow-gold"],
    ["Żółty", "yellow"],
    ["Inny", "other"],
].sort(function (a, b) {
    if (a[0] < b[0]) {
        return -1;
    }
    if (a[0] > b[0]) {
        return 1;
    }
    return 0;
});
exports.COLOR_TYPES_ARRAY = [
    ["Metalik", "metallic"],
    ["Matowy", "matt"],
    ["Perłowy", "pearl"],
];
exports.YEAR_ARRAY = [
    [2024, 2024],
    [2023, 2023],
    [2022, 2022],
    [2021, 2021],
    [2020, 2020],
    [2019, 2019],
    [2018, 2018],
    [2017, 2017],
    [2016, 2016],
    [2015, 2015],
    [2014, 2014],
    [2013, 2013],
    [2012, 2012],
    [2011, 2011],
    [2010, 2010],
    [2009, 2009],
    [2008, 2008],
    [2007, 2007],
    [2006, 2006],
    [2005, 2005],
    [2004, 2004],
    [2003, 2003],
    [2002, 2002],
    [2001, 2001],
    [2000, 2000],
    [1999, 1999],
    [1998, 1998],
    [1997, 1997],
    [1996, 1996],
    [1995, 1995],
    [1994, 1994],
    [1993, 1993],
    [1992, 1992],
    [1991, 1991],
    [1990, 1990],
    [1989, 1989],
    [1988, 1988],
    [1987, 1987],
    [1986, 1986],
    [1985, 1985],
    [1984, 1984],
    [1983, 1983],
    [1982, 1982],
    [1981, 1981],
    [1980, 1980],
    [1979, 1979],
    [1978, 1978],
    [1977, 1977],
    [1976, 1976],
    [1975, 1975],
    [1974, 1974],
    [1973, 1973],
    [1972, 1972],
    [1971, 1971],
    [1970, 1970],
    [1969, 1969],
    [1968, 1968],
    [1967, 1967],
    [1966, 1966],
    [1965, 1965],
    [1964, 1964],
    [1963, 1963],
    [1962, 1962],
    [1961, 1961],
    [1960, 1960],
    [1959, 1959],
    [1958, 1958],
    [1957, 1957],
    [1956, 1956],
    [1955, 1955],
    [1954, 1954],
    [1953, 1953],
    [1952, 1952],
    [1951, 1951],
    [1950, 1950]
];
//# sourceMappingURL=Other.js.map